import {
  PEDO_UPPER_RIGHT, PEDO_UPPER_LEFT,
  PEDO_LOWER_RIGHT, PEDO_LOWER_LEFT,
} from './data.js'
import ToothButton from './ToothButton.jsx'

/**
 * 20-tooth primary (pediatric) dentition picker.
 * FDI numbering 51-85, quadrants 5-8.
 *
 * Same dentist-view layout as Adult.
 */
export default function PedoToothChart({ selected, onToggle, readOnly }) {
  const sel = toSet(selected)
  return (
    <div className="inline-block">
      <div className="flex justify-between text-[11px] uppercase tracking-[0.14em] text-violet-400 font-semibold mb-1.5 px-1">
        <span>Upper Right</span>
        <span>Upper Left</span>
      </div>

      <div className="flex items-center gap-1">
        <Row teeth={PEDO_UPPER_RIGHT} sel={sel} onToggle={onToggle} readOnly={readOnly} />
        <div className="w-px h-8 bg-violet-200 mx-0.5" />
        <Row teeth={PEDO_UPPER_LEFT} sel={sel} onToggle={onToggle} readOnly={readOnly} />
      </div>

      <div className="my-1.5 border-t border-dashed border-violet-200" />

      <div className="flex items-center gap-1">
        <Row teeth={PEDO_LOWER_RIGHT} sel={sel} onToggle={onToggle} readOnly={readOnly} />
        <div className="w-px h-8 bg-violet-200 mx-0.5" />
        <Row teeth={PEDO_LOWER_LEFT} sel={sel} onToggle={onToggle} readOnly={readOnly} />
      </div>

      <div className="flex justify-between text-[11px] uppercase tracking-[0.14em] text-violet-400 font-semibold mt-1.5 px-1">
        <span>Lower Right</span>
        <span>Lower Left</span>
      </div>
    </div>
  )
}

function Row({ teeth, sel, onToggle, readOnly }) {
  return (
    <div className="flex items-center gap-1">
      {teeth.map((t) => (
        <ToothButton
          key={t}
          num={t}
          active={sel.has(t)}
          onClick={() => onToggle?.(t)}
          disabled={readOnly}
          tone="violet"
        />
      ))}
    </div>
  )
}

function toSet(v) {
  if (v instanceof Set) return v
  if (Array.isArray(v)) return new Set(v.map(String))
  return new Set()
}
